document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.announcement-bar .note-list-container p:first-child').forEach((el) => {
        el.classList.add('active');
    });

    function rotateAnnouncements() {
        document.querySelectorAll('.announcement-bar .notes-container p.active').forEach((currentNote) => {
            if (currentNote.matches(':last-of-type')) {
                currentNote.classList.remove('active');
                const parent = currentNote.closest('.announcement-bar .note-list-container');
                parent.querySelector('p:first-child').classList.add('active');
                return;
            }
            currentNote.classList.remove('active');
            currentNote.nextElementSibling.classList.add('active');
        });
    }

    setInterval(rotateAnnouncements, 4000);
});






